import { render, staticRenderFns } from "./mainModal.vue?vue&type=template&id=68286b2f"
import script from "./mainModal.vue?vue&type=script&lang=js"
export * from "./mainModal.vue?vue&type=script&lang=js"
import style0 from "./mainModal.vue?vue&type=style&index=0&id=68286b2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports